export default __webpack_public_path__ + "static/kulfi-2ad49796a6d0fe9c00050a7146f98c24.png";